import { Component, OnInit } from '@angular/core';
import { APP_CONFIG, ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  user: any;
  allLanguages = [];
  currentLanguage = '';

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
  ) {}

  ngOnInit(): void {
    this.allLanguages = APP_CONFIG.availableLangs;

    this.currentLanguage = this.configService.getCurrentLanguage();
    this.user = this.userService.userSubject.value;
  }

  logout(): void {
    this.authenticationService.logout();
  }

  changeLanguage(currentLanguage: string): void {
    this.configService.setCurrentLanguage(currentLanguage);
  }
}
